import {
    RefuellingTask,
    RefuellingTaskType,
    translateRefuellingTaskType,
} from 'aos-services/src/services/tasks/types/task/RefuellingTask'
import { TaskTemplate } from 'aos-services/src/services/tasks/types/task/TaskTemplate'
import { PropsListEntry } from 'aos-ui/src/components/list/PropsList'
import { TFunction } from 'i18next'

export const refuellingTaskPropertyList =
    (translate: TFunction) =>
    (t: RefuellingTask | TaskTemplate<RefuellingTask>): PropsListEntry[] => {
        const common = [
            [
                'tasks.task-preview.refuelling-task-type',
                t.refuellingTaskType
                    ? translateRefuellingTaskType(translate)(t.refuellingTaskType)
                    : '-',
            ],
        ] as PropsListEntry[]

        switch (t.refuellingTaskType) {
            case RefuellingTaskType.REFUELLING:
                return [...common, ['tasks.task-preview.aircraftType', t.airplaneType]]
            case RefuellingTaskType.EQUIPMENT_MAINTENANCE:
                return [...common, ['tasks.task-preview.vehicleDetails', t.vehicleDetails]]
            default:
                return [...common]
        }
    }
